var render, staticRenderFns
import script from "./IETip.vue?vue&type=script&lang=js&"
export * from "./IETip.vue?vue&type=script&lang=js&"
import style0 from "./IETip.vue?vue&type=style&index=0&id=dce01724&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce01724",
  null
  
)

export default component.exports